module.exports = __webpack_public_path__ + "img/regular_retrofit.3060dd10.svg";